import {ApiNotificationListResponseDto, ApiNotificationPatchResponseDto, ApiNotificationResponseDto,} from '@birco/rainmesh-api';
import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {NotificationFilter} from '../../../features/notifications/state/notification.state';

export interface NotificationStateService {

  getNotifications(options: NotificationFilter): Observable<ApiNotificationListResponseDto>;

  // getNotificationById(options: { id: string }): Observable<ApiNotificationListResponseDto>;

  markAsRead(options: { id: string }): Observable<ApiNotificationResponseDto>;

  markAllAsRead(): Observable<ApiNotificationPatchResponseDto>;

  deleteAll(): Observable<void>;
}

export const NOTIFICATION_STATE_SERVICE_INJECTION_TOKEN = new InjectionToken<NotificationStateService>('NotificationStateService');
